// "Hampi" + "Hampi" -> "Hampi"; "Kabini" + "Mysuru" -> "Kabini, Mysuru"
function placeName(area, city) {
    const a = String(area || '').trim();
    const c = String(city || '').trim();
    if (!a || !c || a.toLowerCase() === c.toLowerCase()) return a || c;
    return `${a}, ${c}`;
}

export default function formatedTripData(item, type) {
    const USER_IDS = ['686f837afe8ded032c47991a', '6892ebe235b0fc3f961f5146', '6a2269bb48c4821d006de9c6'];

    const userId = window.localStorage.getItem('userId') || null;

    /* =========================================================
       CAMP / ACCOMMODATION
    ========================================================= */

    if (type === 'camp') {
        /*
         * -----------------------------------------
         * BASIC DATA
         * -----------------------------------------
         */

        const title = item?.title || '';

        const _id = item?._id;

        const images = item?.cardImages?.length
            ? item.cardImages
            : item?.media?.filter((media) => media?.type === 'image')?.map((media) => media.url) || [];

        /*
         * -----------------------------------------
         * LOCATION
         * -----------------------------------------
         */

        const city = item?.address?.city || '';

        const state = item?.address?.state || '';

        const country = item?.address?.country || '';

        const locationParts = [city, state].filter(Boolean);

        const location = locationParts.join(', ');

        const where = location || country || '';

        /*
         * -----------------------------------------
         * PROPERTY TYPE
         * -----------------------------------------
         */

        const propertyType = item?.propertyType || '';

        const propertyCategory = item?.propertyCategory || '';

        /*
         * -----------------------------------------
         * FIRST UNIT
         * -----------------------------------------
         *
         * Accommodation pricing is inside:
         *
         * units[]
         *   └── pricing[]
         *
         */

        const firstUnit = item?.units?.[0] || {};

        const firstPricing = firstUnit?.pricing?.[0] || {};

        /*
         * Search results send `availability` instead of all units:
         * the cheapest unit that is free for the searched dates and
         * guests (backend: utils/search/campAvailability.js).
         */
        const avail = item?.availability?.unit || null;

        /*
         * -----------------------------------------
         * PRICE
         * -----------------------------------------
         */

        const actualPrice = Number(avail?.price ?? firstPricing?.actualPrice ?? firstPricing?.basePrice ?? 0);

        const strikePrice = Number(avail?.strikePrice ?? firstPricing?.strikePrice ?? 0);

        const discountAmount = Number(firstPricing?.discountAmount ?? 0);

        let discountPercent = Number(avail?.discountPercent ?? firstPricing?.discountPercent ?? 0);

        /*
         * If backend doesn't provide discountPercent
         * but has strikePrice, calculate it.
         */

        if (discountPercent === 0 && strikePrice > actualPrice && strikePrice > 0) {
            discountPercent = Math.round(((strikePrice - actualPrice) / strikePrice) * 100);
        }

        /*
         * -----------------------------------------
         * DISPLAY PRICE
         * -----------------------------------------
         *
         * For accommodation we use actual/base price
         * as the main displayed price.
         */

        const finalDisplayPrice = actualPrice;

        /*
         * -----------------------------------------
         * PRICE UNIT
         * -----------------------------------------
         */

        const priceUnit = avail?.priceUnit || firstPricing?.priceUnit || 'per_night';

        /*
         * -----------------------------------------
         * RATING
         * -----------------------------------------
         */

        const rating = Number(item?.rating?.average ?? item?.rating ?? 0);

        /*
         * -----------------------------------------
         * GUEST CAPACITY
         * -----------------------------------------
         */

        const maxGuests = Number(item?.maxGuests ?? firstUnit?.maximumGuests ?? firstUnit?.occupancy?.total ?? 0);

        /*
         * -----------------------------------------
         * SEARCH GUESTS
         * -----------------------------------------
         *
         * These can be attached later from the search
         * query if the search-result page passes them.
         *
         * For now, keep the property's capacity separate.
         */

        const guests = item?.stay?.guests || maxGuests;

        /*
         * -----------------------------------------
         * PROPERTY DISPLAY NAME
         * -----------------------------------------
         */

        const displayPropertyType = propertyType || propertyCategory || 'Stay';

        /*
         * -----------------------------------------
         * CHECK-IN / CHECK-OUT
         * -----------------------------------------
         *
         * Search-result dates are not part of the
         * accommodation document itself.
         *
         * They can be supplied through item.searchData
         * if the search result attaches them.
         */

        const checkin = item?.checkin || item?.stay?.checkIn || item?.searchData?.checkin || '';

        const checkout = item?.checkout || item?.stay?.checkOut || item?.searchData?.checkout || '';

        /*
         * -----------------------------------------
         * ORGANIZER
         * -----------------------------------------
         */

        const organizerName = item?.organizerName || null;

        /*
         * -----------------------------------------
         * RETURN CAMP FORMAT
         * -----------------------------------------
         */

        return {
            title,

            where,

            location,

            images,

            _id,

            rating,

            organizerName,

            actualPrice,

            finalDisplayPrice,

            strikePrice,

            discountAmount,

            discountPercent,

            priceUnit,

            propertyType,

            propertyCategory,

            guests,

            maxGuests,

            checkin,

            checkout,

            /*
             * Availability for the searched dates (search results only)
             */
            unitName: avail?.name || '',

            roomsNeeded: avail?.roomsNeeded || null,

            unitsLeft: avail?.left ?? null,

            fewLeft: Boolean(avail?.fewLeft),

            mealPlan: avail?.mealPlan || '',

            refundable: Boolean(avail?.refundable),

            nights: item?.stay?.nights || null,

            /*
             * Existing ListingCard props.
             * These are kept so the same card can
             * render Camp without breaking Trip.
             */

            firstDate: checkin || null,

            moreDates: checkout || null,

            duration: displayPropertyType,

            difficulty: '',

            daysAndNight: '',

            group: '',

            datesType: '',

            camp: true
        };
    }

    /* =========================================================
       EXISTING TRIP / GUIDE / ACTIVITY LOGIC
       DO NOT CHANGE
    ========================================================= */

    const { baseCities = [] } = item?.quickView || {};

    // activities / guides have no `where`: show the area + city on the image instead
    const where =
        item?.quickView?.where ||
        (type === 'act' || type === 'gu'
            ? placeName(item?.quickView?.area, String(baseCities || '').split(',')[0])
            : '');

    const images = item?.cardImages;

    const formattedDates = Array.isArray(item?.futureDates)
        ? item.futureDates.map((date) =>
              new Date(date)
                  .toLocaleString('en-US', {
                      month: 'short',
                      day: '2-digit'
                  })
                  .replace(',', '')
          )
        : [];

    const title = item?.title;

    const daysAndNight = `${item?.days}D/${item?.nights}N`;

    const organizerName = USER_IDS.includes(userId) ? item?.organizerName : null;

    const firstDate = formattedDates[0] || null;

    const moreDates = formattedDates.slice(1).join(' | ') || null;

    const startCityLocation = typeof baseCities === 'string' ? baseCities.split(',') : [];

    let reservePrice;

    let installmentPrice;

    let actualPrice;

    let group;

    let datesType;

    /*
     * =====================================================
     * ACTIVITY
     * =====================================================
     */

    // activity / guide: the ticket the card's price comes from (for the strike price)
    let priceEntry = null;

    if (type === 'act') {
        reservePrice = item?.price?.[0]?.reserve || 0;

        installmentPrice = item?.price?.[0]?.instalments?.[0]?.amount || 0;

        // first ticket (usually Adult), same as before
        priceEntry = item?.price?.[0] || null;

        actualPrice = priceEntry?.actual || 0;
    } else if (type === 'gu') {

    /*
     * =====================================================
     * GUIDE
     * =====================================================
     */
        reservePrice = item?.price?.[0]?.reserve || 0;

        installmentPrice = item?.price?.[0]?.instalments?.[0]?.amount || 0;

        const lowestPrice = item?.price?.reduce((lowest, current) => {
            if (!lowest || current.perPersonPrice < lowest.perPersonPrice) {
                return current;
            }

            return lowest;
        }, null);

        actualPrice = lowestPrice?.perPersonPrice || 0;

        priceEntry = lowestPrice;
    } else {

    /*
     * =====================================================
     * TRIP
     * =====================================================
     */
        reservePrice = item?.price?.[0]?.price?.reserve || item?.price?.[0]?.customPrice?.reserve || 0;

        installmentPrice = item?.price?.[0]?.instalments?.[0]?.amount || 0;

        actualPrice = item?.price?.[0]?.price?.actual || item?.price?.[0]?.customPrice?.perPerson || 0;

        group = item?.group === 'vehicle' ? 'Rides' : item?.group;

        datesType = item?.datesType;
    }

    /*
     * =====================================================
     * FINAL DISPLAY PRICE
     * =====================================================
     */

    let finalDisplayPrice;

    if (reservePrice === 0 && installmentPrice === 0) {
        finalDisplayPrice = actualPrice;
    } else if (reservePrice > 0 && installmentPrice > 0) {
        finalDisplayPrice = Math.min(reservePrice, installmentPrice);
    } else {
        finalDisplayPrice = reservePrice || installmentPrice;
    }

    /*
     * =====================================================
     * COMMON DATA
     * =====================================================
     */

    const rating = item?.rating;

    const _id = item?._id;

    const duration = item?.quickView?.duration;

    const difficulty = item?.quickView?.difficulty;

    /*
     * =====================================================
     * ACTIVITY / GUIDE EXTRAS
     * =====================================================
     * These have no quickView.where: the place is the area + city.
     */
    const isSlotType = type === 'act' || type === 'gu';

    const area = item?.quickView?.area || '';

    const place = isSlotType ? placeName(area, startCityLocation[0]) : '';

    const languages = type === 'gu' ? (item?.quickView?.languages || []).filter(Boolean) : [];

    const timings =
        isSlotType && item?.openTime && item?.closeTime
            ? `${item.openTime} - ${item.closeTime}`
            : isSlotType && item?.timeSlots?.length
              ? item.timeSlots.length > 1
                  ? `${item.timeSlots.length} slots a day`
                  : `${item.timeSlots[0].startTime} - ${item.timeSlots[0].endTime}`
              : '';

    // organizer's own strike price / discount when given (else the card works one out)
    const strikePrice = isSlotType && priceEntry?.higherPrice > actualPrice ? priceEntry.higherPrice : 0;

    const discountPercent = isSlotType && strikePrice ? Number(priceEntry?.discountPer) || 0 : 0;

    return {
        title,

        where,

        images,

        firstDate,

        moreDates,

        location: startCityLocation.slice(0, 2),

        finalDisplayPrice,

        rating,

        daysAndNight,

        organizerName,

        group,

        datesType,

        _id,

        actualPrice,

        duration,

        difficulty,

        // activity / guide
        place,

        languages,

        timings,

        reviewCount: Number(item?.reviewCount) || 0,

        category: isSlotType ? item?.quickView?.type?.[0] || '' : '',

        availability: isSlotType ? (item?.datesType === 'everyday' ? 'Everyday' : 'Selected dates') : '',

        strikePrice,

        discountPercent
    };
}
